import { motion } from "framer-motion";
import { REEL_MOMENTS } from "@/lib/data";

export default function ReelMoments() {
  return (
    <section
      id="moments"
      data-testid="moments-section"
      className="relative bg-[#050505] py-24 md:py-40 border-t border-white/10"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="flex items-center gap-3 mb-10">
          <span className="font-mono-label text-[10px] text-[#C4A484]">
            003 · Reel Moments
          </span>
          <span className="flex-1 h-px bg-white/10" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-20">
          <h2 className="md:col-span-8 font-heading text-5xl md:text-7xl tracking-tighter leading-[0.95]">
            Some moments last
            <br />
            <span className="italic text-[#C4A484]">seconds.</span>
            <br />
            We make them last
            <br />
            generations.
          </h2>
          <p className="md:col-span-4 md:pt-6 text-[#8F8F8F] text-sm leading-relaxed">
            Every wedding hides a few frames worth keeping forever. We review
            thousands of them so you never miss the one tear your father tried
            to hide.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10">
          {REEL_MOMENTS.map((m, i) => (
            <motion.div
              key={m.id}
              data-testid={`moment-${m.id}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: (i % 2) * 0.15 }}
              viewport={{ once: true }}
              className="group relative"
            >
              <div className="relative aspect-[5/4] overflow-hidden">
                <img
                  src={m.image}
                  alt={m.label}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1500ms] group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" />
                <div className="absolute top-5 left-5 flex items-center gap-3">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#C4A484] animate-pulse" />
                  <span className="font-mono-label text-[10px] text-[#FDFBF7]">
                    REC · {m.duration}
                  </span>
                </div>
                <div className="absolute bottom-5 left-5 font-mono-label text-[10px] text-[#C4A484]">
                  {m.label}
                </div>
              </div>
              <div className="mt-6">
                <p className="font-heading text-2xl md:text-3xl tracking-tighter text-[#FDFBF7] leading-tight max-w-lg">
                  &ldquo;{m.caption}&rdquo;
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
